import APIServiceLookUp from './serviceAPI';
import { API_URL } from './models/AppConstent';

export default class ServiceBlog {
    lookupService = new APIServiceLookUp();

    async getAllBlog(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}blog/getAllBlog`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async setBlog(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}blog/setBlog`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async updateBlog(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}blog/updateBlog`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async delBlog(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}blog/delBlog`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async getAllBlogSection(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}blog/getAllBlogSection`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async updateBlogSection(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}blog/updateBlogSection`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

}
